enum SocialTypeValue {
  FACEBOOK = 1,
  LINE = 2,
  GOOGLE = 3,
  APPLE = 4,
}

export default SocialTypeValue;
